import {
  FormField,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

import type { NotebookRecurrence } from "@/utils/notebook-recurrence"

export function NotebookRepeatFields({
  value,
  onChange,
  disabled = false,
  errors,
}: {
  value: NotebookRecurrence
  onChange: (value: NotebookRecurrence) => void
  disabled?: boolean
  errors?: Partial<Record<"interval" | "time" | "timezone", string>>
}) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <FormField label="Repeat every" error={errors?.interval}>
          {(ids) => (
            <Input
              {...ids}
              type="number"
              min={1}
              max={365}
              value={value.interval}
              disabled={disabled}
              onChange={(event) =>
                onChange({ ...value, interval: Number(event.target.value) })
              }
            />
          )}
        </FormField>
        <FormField label="Period">
          {(ids) => (
            <Select
              value={value.cadence}
              disabled={disabled}
              onValueChange={(cadence) =>
                onChange({
                  ...value,
                  cadence: cadence as NotebookRecurrence["cadence"],
                })
              }
            >
              <SelectTrigger {...ids}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="daily">Days</SelectItem>
                <SelectItem value="weekly">Weeks</SelectItem>
                <SelectItem value="monthly">Months</SelectItem>
              </SelectContent>
            </Select>
          )}
        </FormField>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <FormField label="At" error={errors?.time}>
          {(ids) => (
            <Input
              {...ids}
              type="time"
              value={value.time}
              disabled={disabled}
              onChange={(event) =>
                onChange({ ...value, time: event.target.value })
              }
            />
          )}
        </FormField>
        <FormField
          label="Timezone"
          error={errors?.timezone}
          description="For example America/Los_Angeles or Europe/London."
        >
          {(ids) => (
            <Input
              {...ids}
              value={value.timezone}
              disabled={disabled}
              onChange={(event) =>
                onChange({ ...value, timezone: event.target.value })
              }
            />
          )}
        </FormField>
      </div>
    </div>
  )
}
